export default __webpack_public_path__ + "static/media/thunder.260cad2e.svg";